const problems = [
  'сотрудники постоянно обращаются к руководителю с одинаковыми вопросами;',
  'новые сотрудники долго выходят на рабочую эффективность;',
  'опыт отдельных специалистов не передаётся другим;',
  'компания зависит от нескольких «звёзд»;',
  'руководитель постоянно обучает сотрудников вместо управления;',
  'сильные специалисты не развиваются в сторону руководящих ролей;',
  'нет понятного кадрового резерва;',
  'при увольнении опытного сотрудника компания теряет критически важные знания;',
  'сотрудники боятся принимать решения самостоятельно.',
];

export default function WhyDevelopEmployees() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Руководитель не может быть единственным носителем знаний
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Когда руководитель сам решает все задачи и отвечает на все вопросы, команда не растёт. Вот реальные проблемы, которые возникают, если развитие сотрудников не выстроено:
        </p>

        <div className="grid sm:grid-cols-1 gap-3 max-w-4xl mx-auto mb-12">
          {problems.map((p, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-alert-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{p}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Если руководитель постоянно решает проблемы за сотрудников, команда не становится самостоятельнее. Наставничество должно постепенно передавать сотруднику не только знания, но и ответственность.
          </p>
        </div>
      </div>
    </section>
  );
}